import React, { useContext } from 'react';
import { Pagination, PaginationDisplayedItemCount } from '@one-thd/sui-atomic-components';
import proptypes from 'prop-types';
const { func, number, bool, arrayOf, shape } = proptypes;
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { ProjectTile } from './project-tile/ProjectTile';
import { LoadingProjectSummary } from './LoadingProjectSummary';
import { EmptyStateMessage } from './EmptyStateMessage/EmptyStateMessage';

export const CardView = ({
  projects, loading, onPageChange, totalPages, page, totalResults
}) => {

  const NUMBER_PLACEHOLDERS = 6;
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';

  if (!projects?.length && loading) {
    return (
      <LoadingProjectSummary numberPlaceholders={NUMBER_PLACEHOLDERS} />
    );
  }

  // Show "no results" message when there are no projects and not loading
  if (!projects?.length && !loading) {
    return <EmptyStateMessage />;
  }

  return (
    <>
      {(projects?.length > 0) && (
        <div
          className="sui-grid sui-gap-3 sui-grid-cols-1 md:sui-grid-cols-2
      lg:sui-grid-cols-3"
          data-testid="projects-card-view"
        >
          {
          projects?.map((project) => (
            <ProjectTile
              key={project.projectId}
              projectId={project.projectId}
              project={project}
              loading={loading}
              disableAction={false}
              onClick={() => {}}
            />
          ))
          }
        </div>
      )}
      <div className="sui-mt-4" data-testid="projects-card-pagination">
        {
          (!!totalPages && !isMobile) && (
            <div className="sui-col-span-4 sui-flex sui-justify-center sui-items-center" data-testid="lists-pagination">
              <PaginationDisplayedItemCount
                page={page}
                itemsPerPage={12}
                items={totalResults}
              />
              <Pagination
                page={page}
                onChange={onPageChange}
                count={totalPages}
              />
            </div>
          )
        }
        {
          (!!totalPages && isMobile) && (
            <div className="sui-col-span-4 sui-flex sui-flex-col sui-items-center" data-testid="lists-pagination">
              {/* <PaginationCompact
                page={page}
                onChange={onPageChange}
                count={totalPages}
              /> */}
              <Pagination
                page={page}
                onChange={onPageChange}
                count={totalPages}
                boundaryCount={0}
              />
              <div className="sui-mt-2">
                <PaginationDisplayedItemCount
                  page={page}
                  itemsPerPage={12}
                  items={totalResults}
                />
              </div>
            </div>
          )
        }
      </div>
    </>
  );
};

CardView.propTypes = {
  projects: arrayOf(shape({})),
  totalPages: number,
  page: number,
  onPageChange: func,
  loading: bool,
  totalResults: number
};

CardView.defaultProps = {
  projects: [],
  totalPages: null,
  page: 1,
  onPageChange: () => {},
  loading: false,
  totalResults: 0
};
